export const environment = {
  production: true,
  url: "in production document.getElementsByTagName('base')[0].href is used",
  colorSetting: ""
};
